export default "__VITE_PUBLIC_ASSET__0d1fc4eb__"